<!-- @format -->

<template>
	<div class="pc-anchor">
		<header>{{ title }}</header>
		<el-timeline>
			<el-timeline-item
				v-for="(item, index) in data"
				:key="getId(item)"
				:type="(!activeAnchor && index === 0) || activeAnchor === getId(item) ? 'primary' : 'info'"
				:hide-timestamp="true"
				:hollow="true"
			>
				<el-link
					:href="`#${getId(item)}`"
					:underline="false"
					class="pc-anchor-item-link"
					:type="activeAnchor === getId(item) ? 'primary' : 'default'"
					@click="onAnchor(getId(item))"
				>
					<span>{{ getLabel(item) }}</span>
				</el-link>
			</el-timeline-item>
		</el-timeline>
	</div>
</template>

<script setup lang="ts">
	interface Props {
		title?: string;
		data: any[];
		getId: (a: any) => string;
		getLabel: (a: any) => string;
		renderId: string;
		scroll?: string;
	}

	const props = withDefaults(defineProps<Props>(), { title: '' });

	const route = useRoute();

	const activeAnchor = ref<string>('');

	const onAnchor = (id: string) => {
		activeAnchor.value = id;
	};

	const navs = ref([] as any);
	const scroll = ref({} as Element | Window);

	// 滚动监听器
	const onScroll = () => {
		// 所有锚点元素的 offsetTop
		const offsetTopArr: number[] = [];
		navs.value.forEach((v) => {
			offsetTopArr.push(v.offsetTop);
		});

		const scroll2 = scroll.value instanceof Element ? scroll.value.scrollTop : undefined;

		// 获取当前文档流的 scrollTop
		const scrollTop = scroll2 || document.documentElement.scrollTop || document.body.scrollTop;
		// 定义当前点亮的导航下标
		offsetTopArr.forEach((v, k) => {
			if (scrollTop >= v - 10) {
				onAnchor(props.data[k].code);
			}
		});
	};

	let observer: ResizeObserver;

	onMounted(() => {
		if (route.hash && route.hash[0] === '#') {
			setTimeout(() => {
				const id = route.hash.slice(1);
				onAnchor(id);
				document.getElementById(id)?.scrollIntoView({
					block: 'start',
					behavior: 'smooth',
				});
			}, 300);
		}
		const container = document.getElementById(props.renderId) as Element;
		observer = new ResizeObserver(() => {
			if (props.scroll) {
				scroll.value = document.querySelector(props.scroll) as Element;
			} else {
				scroll.value = window;
			}
			// 获取所有锚点元素
			const containerArr: any = [];
			for (const key in props.data) {
				if (Object.prototype.hasOwnProperty.call(props.data, key)) {
					const element = props.data[key];
					containerArr.push(document.getElementById(element.code));
				}
			}
			navs.value = containerArr;
			scroll.value?.addEventListener('scroll', onScroll);
		});
		observer.observe(container as any);
	});

	onUnmounted(() => {
		scroll.value?.removeEventListener('scroll', onScroll);
		observer.disconnect();
	});
</script>

<style scoped lang="scss">
	.pc-anchor {
		position: sticky;
		top: 10px;

		.el-timeline {
			padding: 0;
		}

		.pc-anchor-item-link {
			width: 100%;
			display: block;
		}
	}
</style>
